// eslint-disable-next-line import/prefer-default-export
export enum ENoteType {
  List = 'list',
  String = 'string',
  Header = 'header',
}
